const Fetcher = require('od-modules/utils/fetcher');

const BOOKING_CHANGE_REQUEST = '/travel/service/bookingchangerequest/check';

const STATUS_LIST = [
    'REQUESTED',
    'PRIORITISING',
    'PROCESSING',
    'AGENT_REVIEW',
    'AIRLINE_PENDING,',
];

const getBookingChangeRequestUrl = (bookingId) => `${BOOKING_CHANGE_REQUEST}/${bookingId}`;

const getBookingChangeRequest = (bookingId) => Fetcher.get(getBookingChangeRequestUrl(bookingId)).json();

class Status {
    constructor({bookingId, keys = {}} = {}) {
        this.keys = keys;
        this.valid = false;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        getBookingChangeRequest(bookingId)
            .then(this.load.bind(this))
            .catch(() => this.resolve(false));
    }

    load({changeRequestStatus, requestType} = {}) {
        this.status = changeRequestStatus;
        this.index = STATUS_LIST.indexOf(changeRequestStatus);
        this.valid = this.index >= 0 && requestType === 'DATE_CHANGE';
        this.resolve(true);
    }

    isValid() {
        return this.valid;
    }

    then(handler = () => {}) {
        return this.promise.then(handler);
    }

    get info() {
        return this.valid
            ? {
                status: this.status,
                description: this.keys[`changesNotificationStatus::${this.status}`],
                currentStep: this.index + 1,
                totalSteps: STATUS_LIST.length,
            }
            : {};
    }
}

module.exports = Status;
